import { CamelCasedPropertiesDeep } from 'type-fest';

import type {
  Subscription,
  SubscriptionProduct,
  SubscriptionResumptionCharge,
} from './subscription';
import { SubscriptionPaymentProfile } from './subscriptionPaymentProfile';
import {
  SubscriptionComponent,
  SubscriptionComponentPriceStep,
} from './subscriptionComponent';
import type { ProductFamily } from './productFamily';
import type { CustomerDetails } from './customerDetails';
import { GatewayConfig } from './gatewayConfig';
import { Division } from './addressDetails';
import { CustomField } from './customField';
import { BillingPortalSettings } from './settings';

import {
  Allocation,
  AllocationsError,
  AllocationsPreview,
  AllocationDetails,
} from './componentAllocation';
import { InvoicesList, InvoicesParams } from './invoicesList';
import { BankAccount, CreditCard } from './paymentProfiles';
export type { BillingPortalSettings };
export type APIResponse<R> = CamelCasedPropertiesDeep<R>;

export enum HttpMethod {
  GET = 'get',
  POST = 'post',
  PUT = 'put',
  DELETE = 'delete',
}

export type {
  SubscriptionProduct,
  CreditCard,
  BankAccount,
  ProductFamily,
  SubscriptionComponent,
  SubscriptionComponentPriceStep,
  SubscriptionResumptionCharge,
  Subscription,
  SubscriptionPaymentProfile,
  CustomerDetails,
  GatewayConfig,
  Division,
  Allocation,
  AllocationsError,
  AllocationsPreview,
  AllocationDetails,
  CustomField,
  InvoicesList,
  InvoicesParams,
};
